import React, { useEffect, useState, useRef } from "react";
import {
    useTheme,
    styled,
    TableCell,
    TableRow,
    FormControl,
    Select,
    MenuItem,
    Box,
    Tooltip,
    Typography,
} from "@mui/material";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import StyledTypography from "../common/StyledTypography";
import ProjectService from "../api/project";
import { useSelector } from "react-redux";
import ViewButton from "../common/viewButton.js";
import CommentButton from "../common/commentButton.js";
import { useNavigate } from "react-router-dom";
import Off from "../common/images/robot_icons/light_off.svg";
import Green from "../common/images/robot_icons/green_light_on.svg";
import Red from "../common/images/robot_icons/red_light_on.svg";
import Yellow from "../common/images/robot_icons/yellow_light_on.svg";
import Orange from "../common/images/robot_icons/orange_light_on.svg";
import handleNavigate from "../common/customFunctions/handleNavigate";

const CustomSelect = styled(Select)(({ theme }) => ({
    background: theme.palette.custom.inputBackgroundColor,
    height: "36px",
    width: "100%",
    minWidth: "100px",
    color: theme.palette.custom.text,
    outlineColor: theme.palette.custom.borderColor,
    "&.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.custom.borderColor,
        color: theme.palette.custom.borderColor,
    },
    "&.Mui-focused": {
        color: theme.palette.custom.text,
    },
    "&:focused": {
        color: theme.palette.custom.borderColor,
    },
    "& .MuiList-root": {
        backgroundColor: theme.palette.custom.inputBackgroundColor,
    },
}));

function CommentTableCell({ comment, handleCommentClick }) {
    return (
        <TableCell
            align="left"
            onClick={handleCommentClick}
            sx={{ padding: "8px 16px", minHeight: "56px" }}
        >
            <Tooltip title={comment}>
                <Box
                    sx={{
                        minWidth: 100,
                        maxWidth: 200,
                        display: "block",
                        overflow: "hidden",
                        whiteSpace: "normal",
                        textOverflow: "ellipsis",
                        lineHeight: "1.5em",
                        maxHeight: "3em",
                    }}
                >
                    <Typography variant="subtitle2" noWrap={true}>
                        {comment}
                    </Typography>
                </Box>
            </Tooltip>
        </TableCell>
    );
}
CommentTableCell.propTypes = {
    comment: PropTypes.string,
    handleCommentClick: PropTypes.func,
};
export default function MachineDocumentationTableRow({
    row,
    handleChangeDocsData,
    iKey,
    projectID,
    hidden,
}) {
    console.log(row);
    const organziation = useSelector(({ organziation }) => organziation);
    const orgObj =
        organziation ?? JSON.parse(localStorage.getItem("defaultOrganization"));
    const apiKey = orgObj?.api_key_list?.[0]?.key;
    const [openSelects, setOpenSelects] = useState({});
    const [imageSources, setImageSources] = useState({});
    const [comment, setComment] = useState(row.latest_comment);
    const imageRef = useRef(null);
    const navigate = useNavigate();
    const theme = useTheme();
    const handleChange = (event) => {
        const { name, value } = event.target;
        const col = name.split("?")[1];
        const paramID = name.split("?")[0];
        handleChangeDocsData(row, value, name, row.tasks);
        updateImageSource(paramID, value, col);
        ProjectService.SetParamVal("", name, value, "active", apiKey);
    };

    const handleImageClick = (event) => {
        let taskParamId = event.target.id;
        setOpenSelects((prevState) => ({
            ...prevState,
            [taskParamId]: !prevState[taskParamId],
        }));
    };

    const updateImageSource = (taskParamId, value, col) => {
        let newSrc = "robot_icons/light_off.svg"; // default image
        if (col === "Risk") {
            switch (value) {
                case 0:
                    newSrc = Off;
                    break;
                case 1:
                    newSrc = Green;
                    break;
                case 2:
                    newSrc = Yellow;
                    break;
                case 3:
                    newSrc = Orange;
                    break;
                case 4:
                    newSrc = Red;
                    break;
                default:
                    newSrc = Off;
            }
        } else {
            switch (value) {
                case 0:
                    newSrc = Off;
                    break;
                case 1:
                    newSrc = Green;
                    break;
                case 2:
                    newSrc = Red;
                    break;

                default:
                    newSrc = Off;
            }
        }

        setImageSources((prevState) => ({
            ...prevState,
            [taskParamId]: newSrc,
        }));
    };

    const CustomSelectImage = styled(Select)(({ name }) => ({
        background: "transparent",
        height: "40px",
        width: "40px",
        color: "transparent",
        outlineColor: "transparent",
        backgroundImage: `url(${imageSources[name.toString()]})`,
        backgroundRepeat: "no-repeat",
        "&root": {
            borderColor: "transparent",
            color: "transparent",
            border: "0",
        },
        "&.MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
            color: "transparent",
            border: "0",
        },
        "&.Mui-focused": {
            color: "transparent",
        },
        "&:focused": {
            color: "transparent",
        },
        "&:before": {
            display: "none",
            borderColor: "transparent",
            color: "transparent",
            border: "0",
        },
        "& .MuiList-root": {
            backgroundColor: "transparent",
        },
        "&:after": {
            borderColor: "transparent",
            color: "transparent",
            border: "0",
            display: "none",
        },
    }));

    const GetSelectType = (e) => {
        if (hidden) {
            if (e.name === "Risk") {
                return (
                    <CustomSelectImage
                        key={Math.floor(Math.random() * 1000000000)}
                        variant="standard"
                        labelId="Status"
                        value={e.value === "" ? 0 : e.value}
                        name={e.task_param_id}
                        IconComponent={() => null}
                        open={!!openSelects[e.task_param_id]}
                        onClose={() =>
                            setOpenSelects((prevState) => ({
                                ...prevState,
                                [e.task_param_id]: false,
                            }))
                        }
                        onOpen={() =>
                            setOpenSelects((prevState) => ({
                                ...prevState,
                                [e.task_param_id]: true,
                            }))
                        }
                        onChange={handleChange}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    backgroundColor: theme.palette.custom.inputBackgroundColor,
                                    "& .MuiMenuItem-root.Mui-selected": {
                                        backgroundColor: theme.palette.primary.main,
                                    },
                                    "& .MuiMenuItem-root:hover": {
                                        backgroundColor: theme.palette.custom.buttonHoverColor,
                                    },
                                    "& .MuiMenuItem-root.Mui-selected:hover": {
                                        backgroundColor: theme.palette.custom.backgroundColor2,
                                    },
                                },
                            },
                        }}
                    >
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={0}>
                            Not Set
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={1}>
                            No Risk
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={2}>
                            Low Risk
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={3}>
                            Medium Risk
                        </MenuItem>
                        <MenuItem value={4}>High Risk</MenuItem>
                    </CustomSelectImage>
                );
            } else {
                return (
                    <CustomSelectImage
                        key={Math.floor(Math.random() * 1000000000)}
                        variant="standard"
                        labelId="Status"
                        value={e.value === "" ? 0 : e.value}
                        name={e.task_param_id}
                        IconComponent={() => null}
                        open={!!openSelects[e.task_param_id]}
                        onClose={() =>
                            setOpenSelects((prevState) => ({
                                ...prevState,
                                [e.task_param_id]: false,
                            }))
                        }
                        onOpen={() =>
                            setOpenSelects((prevState) => ({
                                ...prevState,
                                [e.task_param_id]: true,
                            }))
                        }
                        onChange={handleChange}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    backgroundColor: theme.palette.custom.inputBackgroundColor,
                                    "& .MuiMenuItem-root.Mui-selected": {
                                        backgroundColor: theme.palette.primary.main,
                                    },
                                    "& .MuiMenuItem-root:hover": {
                                        backgroundColor: theme.palette.custom.buttonHoverColor,
                                    },
                                    "& .MuiMenuItem-root.Mui-selected:hover": {
                                        backgroundColor: theme.palette.custom.backgroundColor2,
                                    },
                                },
                            },
                        }}
                    >
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={0}>
                            Not Set
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={1}>
                            Yes
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={2}>
                            No
                        </MenuItem>
                    </CustomSelectImage>
                );
            }
        } else {
            if (e.name === "Risk") {
                return (
                    <CustomSelect
                        key={Math.floor(Math.random() * 1000000000)}
                        labelId="Status"
                        value={e.value === "" ? 0 : e.value}
                        name={e.task_param_id}
                        open={hidden ? false : !!openSelects[e.task_param_id]}
                        onClose={() =>
                            setOpenSelects((prevState) => ({
                                ...prevState,
                                [e.task_param_id]: false,
                            }))
                        }
                        onOpen={() =>
                            setOpenSelects((prevState) => ({
                                ...prevState,
                                [e.task_param_id]: true,
                            }))
                        }
                        onChange={handleChange}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    backgroundColor: theme.palette.custom.inputBackgroundColor,
                                    "& .MuiMenuItem-root.Mui-selected": {
                                        backgroundColor: theme.palette.primary.main,
                                    },
                                    "& .MuiMenuItem-root:hover": {
                                        backgroundColor: theme.palette.custom.buttonHoverColor,
                                    },
                                    "& .MuiMenuItem-root.Mui-selected:hover": {
                                        backgroundColor: theme.palette.custom.backgroundColor2,
                                    },
                                },
                            },
                        }}
                    >
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={0}>
                            Not Set
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={1}>
                            No Risk
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={2}>
                            Low Risk
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={3}>
                            Medium Risk
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={4}>
                            High Risk
                        </MenuItem>
                    </CustomSelect>
                );
            } else {
                return (
                    <CustomSelect
                        key={Math.floor(Math.random() * 1000000000)}
                        labelId="Status"
                        value={e.value === "" ? 0 : e.value}
                        name={e.task_param_id}
                        open={hidden ? false : !!openSelects[e.task_param_id]}
                        onClose={() =>
                            setOpenSelects((prevState) => ({
                                ...prevState,
                                [e.task_param_id]: false,
                            }))
                        }
                        onOpen={() =>
                            setOpenSelects((prevState) => ({
                                ...prevState,
                                [e.task_param_id]: true,
                            }))
                        }
                        onChange={handleChange}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    backgroundColor: theme.palette.custom.inputBackgroundColor,
                                    "& .MuiMenuItem-root.Mui-selected": {
                                        backgroundColor: theme.palette.primary.main,
                                    },
                                    "& .MuiMenuItem-root:hover": {
                                        backgroundColor: theme.palette.custom.buttonHoverColor,
                                    },
                                    "& .MuiMenuItem-root.Mui-selected:hover": {
                                        backgroundColor: theme.palette.custom.backgroundColor2,
                                    },
                                },
                            },
                        }}
                    >
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={0}>
                            Not Set
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={1}>
                            Yes
                        </MenuItem>
                        <MenuItem key={Math.floor(Math.random() * 1000000000)} value={2}>
                            No
                        </MenuItem>
                    </CustomSelect>
                );
            }
        }
    };

    useEffect(() => {
        row.tasks.forEach((task) => {
            updateImageSource(
                task.task_param_id?.toString(),
                Number(task.value),
                task.name
            );
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function handleCommentAdd() {
        let inputValue;
        const { value: comment } = await Swal.fire({
            title: "Add Comment",
            showCancelButton: true,
            confirmButtonText: "Post",
            color: theme.palette.custom.text,
            background: theme.palette.custom.inputBackgroundColor,
            input: "text",
            inputLabel: "Add Comment",
            inputValue,
            inputValidator: (value) => {
                if (!value) {
                    return "You need to write something!";
                }
            },
        });
        if (comment) {
            await ProjectService.SetGroupComment(
                row.task_group_id,
                comment,
                "active",
                apiKey
            ).then((json) => {
                if (json) {
                    setComment(comment);
                }
            });
        }
    }
    const handleNavigateToEdit = (event) => {
        handleNavigate(
            event,
            navigate,
            `/addMachineDocs?projectId=${projectID}&groupId=${row.task_group_id}`
        );
    };
    const handleCommentClick = (event) => {
        handleNavigate(
            event,
            navigate,
            `/machineComments?groupId=${row.task_group_id}&name=${row.name}`
        );
    };

    return (
        <TableRow
            hover
            role="checkbox"
            tabIndex={-1}
            key={iKey}
            sx={{ cursor: "pointer" }}
        >
            {row.tasks.map((e) =>
                e.name === "U/G ID Number" ||
                    e.name === "Model" ||
                    e.name === "Manufacturer" ||
                    e.name === "Equipment Type" ? (
                    <TableCell align="left" key={e.task_param_id}>
                        <StyledTypography sx={{ ml: "8px" }} variant="subtitle2">
                            {e.value}
                        </StyledTypography>
                    </TableCell>
                ) : (
                    <TableCell align="left" key={e.task_param_id}>
                        <FormControl
                            fullWidth
                            sx={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            {!hidden && (
                                <img
                                    ref={imageRef}
                                    src={imageSources[e.task_param_id?.toString()]}
                                    alt="status_icon"
                                    style={{ width: "40px", height: "40px", cursor: "pointer" }}
                                    onClick={handleImageClick}
                                    id={`${e.task_param_id}`}
                                />
                            )}
                            {GetSelectType(e)}
                        </FormControl>
                    </TableCell>
                )
            )}
            <CommentTableCell
                onClick={handleCommentClick}
                comment={comment}
            ></CommentTableCell>
            <TableCell align="left">
                <Box
                    sx={{ display: "flex", flexFlow: "row", justifyContent: "center" }}
                >
                    <ViewButton onClick={handleNavigateToEdit} />
                    <CommentButton onClick={handleCommentAdd} />
                </Box>
            </TableCell>
        </TableRow>
    );
}
MachineDocumentationTableRow.propTypes = {
    row: PropTypes.object.isRequired,
    handleChangeDocsData: PropTypes.func,
    iKey: PropTypes.number,
    projectID: PropTypes.number,
    hidden: PropTypes.bool,
};
